import React from 'react';
import LoadingItem from './LoadingItem';

//
import Box from '@mui/material/Box';

interface LoadingProps {
  title?:string;
  heightAuto?:boolean;
}
const Loading :React.FC<LoadingProps> = ({ title = 'Loading...', heightAuto }): React.JSX.Element => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: heightAuto ? 'auto' : '550px',
    }}
  >
    <Box sx={{ display: 'column', justifyContent: 'center' }}>
      <LoadingItem />
      <Box sx={{ marginTop: 2 }}>
        <p style={{ textAlign: 'center' }}>{title}</p>
      </Box>
    </Box>
  </Box>
);

export default Loading;
